import Vue from "vue";
let currentRequest = 0;

const InvoicePeriodService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("invoice_periods", id, {});
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START INVOICE_PERIOD `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "invoice_periods",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] INVOICE_PERIOD DISCARDED`);
        return null;
      }
      console.log(`[${request}] END INVOICE_PERIOD `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  },
  async createOrUpdate(payload) {
    try {
      if (payload.id == "" || payload.id == null) {
        return await Vue.$jsonApi.create("invoice_period", payload);
      } else {
        return await Vue.$jsonApi.update("invoice_period", payload);
      }
    } catch (error) {
      console.log("createOrUpdate error: ", error);
      return { error: error };
    }
  },
  async delete(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.destroy("invoice_period", id);
      return data;
    } catch (error) {
      console.log("delete error: ", error);
      return { error: error };
    }
  }
};

export { InvoicePeriodService };
